export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/dfffdcc654f425d556d7485c2bf841db.svg";